import React, { useCallback, useRef, useEffect, useState } from 'react';
import {
  FiLogIn,
  FiMail,
  FiLock,
  FiKey,
  FiMessageCircle,
} from 'react-icons/fi';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import * as Yup from 'yup';
import { Link, useHistory } from 'react-router-dom';
import { rgb } from 'polished';
import {
  FaConnectdevelop,
  FaLock,
  FaHandPointUp,
  FaCertificate,
  FaTicketAlt,
  FaVideo,
  FaAward,
  FaSlideshare,
  FaKey,
} from 'react-icons/fa';
import { MdColorLens, MdMessage } from 'react-icons/md';
import { AiFillSafetyCertificate } from 'react-icons/ai';
import { IconType } from 'react-icons/lib';
import { uuid } from 'uuidv4';
import AreaExposicao from '../AreaExposicao';
import AreaInstitucional from '../AreaInstitucional';
import { ContactIcons, scrollTo, WhatsappIcon } from '../../components/Menu';
import Whatsapp from '../../components/Whatsapp';
import { logo } from '../../config';
import {
  Container,
  SecondaryContainer,
  ContainerWhite,
  GreyContainer,
  Capa,
  ProgramContainer,
  Sponsors,
  Photo,
} from './styles';

import Button from '../../components/Button';
import getValidationErrors from '../../utils/getValidationErrors';

import { useAuth } from '../../hooks/Auth';
import { useToast } from '../../hooks/Toast';
import { useModal } from '../../hooks/Modal';
import SpeakersGrid from '../../components/SpeakersGrid';

import SponsorsComponent from '../Sponsors';


import { usePages } from '../../hooks/Pages';


interface SignInData {
  email: string;
  password: string;
}

interface IPublicData {
  icon: IconType;
  title: string;
  text: string;
}

const SignIn: React.FC = () => {
  const history = useHistory();
  const { signIn } = useAuth();
  const { addToast } = useToast();
  const { addModal, removeModal } = useModal();
  const formRef = useRef<FormHandles>(null);
  const [cardLayout, setCardLayout] = useState([] as Array<JSX.Element>);
  const { readPages } = usePages();

  const [pages, setPages] = useState(readPages());

  /*
  useEffect(() => {
    const keyModal = 'uModal';
    addModal({
      key: keyModal,
      title: 'Seja bem-vindo!',
      content: (
        <>
          <p>
            A área de transmissão já está aberta. 
{' '}
<br />
            Clique abaixo para acessar!
          </p>

          <br />
          <a href="/login" title="login">
            <Button>Acessar Palestras</Button>
          </a>
          <br />
          <p>
            Os certificados já estão disponíveis! 
{' '}
<br />
          </p>

          <a href="/certificados" title="login">
            <Button>Visualizar Certificados</Button>
          </a>
        </>
      ),
    });
  }, []);

  */


  return (<>
    <Capa style={{marginTop: '30px'}}>
      <div className='p50'>
  <div>
    <img src="/assets/logo.png" style={{width: '100%', maxWidth: '350px'}}/>
  </div>
       <div className="p50 capaTitle">
       
       <p style={{border : '5px solid #009d54', borderRadius:'20px', padding: '30px', fontSize:'24px', fontWeight:400}} >
9º SIMPÓSIO PARANAENSE DE <strong>CIRURGIA BARIÁTRICA E METABÓLICA</strong>
</p>
 
  
      
      
  
  </div>
  <p style={{border : '5px solid #009d54', borderRadius:'20px', padding: '15px 30px', marginTop:'20px', fontSize:'18px', fontWeight:400}} > <strong>9 ABR | 8H | HOTEL RADISSON</strong>
</p>
</div>
<div style={{width:'100%', maxWidth: '300px', display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center'}}>
<Link  to="/certificados" style={{'margin': '10px'}}><button className="defaultButton">Certificados</button></Link>
<Link  to="/inscricao" style={{'margin': '10px'}}><button className="defaultButton">Inscreva-se!</button></Link>
  <Link  to="/login" style={{'margin': '10px'}}><button className="defaultButton">Acessar palestra</button></Link>

</div>

    </Capa>
    <Capa id="programacao" style={{marginTop: '30px'}}>
<img style={{width:'100%', maxWidth: '800px', margin:'0px auto'}} src="/apoio/programacao.jpeg"/>
</Capa>
 

    </>
  );
};
export default SignIn;
